export default {
  brewery: 'pfriemstersCellarClub',
  info_url: 'http://landing.tavour.com/pfriemstersCellarClub/',
  title: {
    in_progress: '',
    success: 'You Joined pFriemsters Cellar Club!',
    subtext: 'pFriemsters Cellar Club',
    sub_subtext: 'Delve into our world of award-winning finely brewed creations with the pFriemsters Cellar Club, ' +
      'designed to cater to your love of exceptional beer. Expect quarterly releases in March, June, September and December. ' +
      'Each one packed with exclusive beers, new styles, special discounts with like-minded partners and educational opportunities.',
  },
  review: {
    summary: [
      'You are joining the pFriemsters out-of-state Cellar Club. ' +
      'By signing up, your card will be charged $129.99 for 12 barrel aged bottles, + $22 shipping 4 x per year. ' +
      'You will have the option to opt out by emailing support@tavour.com. You will receive a notification ' +
      'when your box has been charged and shipped!',
    ],
    button_text: 'Join the Cellar Club!',
  },
};



// WEBPACK FOOTER //
// ./src/settings/pfriemsters_cellar_club.js